export const storagePrefixKey = '@dpohub/';

export const authenticatedKey = 'authenticated';
export const userKey = 'user';
export const userNameKey = 'username';
export const emailKey = 'email';
export const adminKey = 'admin';
export const nameKey = 'name';
export const rolesKey = 'roles';
export const tokenKey = 'token';
